import { CanDeactivate } from '@angular/router';
import { Component, HostListener, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkOrderFormUnsavedChangesGuard implements CanDeactivate<WorkOrderFormUnsavedChangesInterface> {
  canDeactivate(component?: WorkOrderFormUnsavedChangesInterface): boolean | Observable<boolean> {
    const workOrderUnsavedChangesComponent: WorkOrderUnsavedChangesComponent =
      component?.getWorkOrderDetailsComponent();
    if (
      workOrderUnsavedChangesComponent?.canDeactivate instanceof Function &&
      workOrderUnsavedChangesComponent?.pendingChangesDialog instanceof Function
    ) {
      if (workOrderUnsavedChangesComponent.canDeactivate()) {
        return true;
      }
      return workOrderUnsavedChangesComponent.pendingChangesDialog();
    } else {
      return true;
    }
  }
}

@Injectable({ providedIn: 'root' })
export class PublicWorkOrderFormUnsavedChangesGuard implements CanDeactivate<WorkOrderUnsavedChangesComponent> {
  canDeactivate(component?: WorkOrderUnsavedChangesComponent): boolean | Observable<boolean> {
    if (component?.canDeactivate instanceof Function && component?.pendingChangesDialog instanceof Function) {
      if (component.canDeactivate()) {
        return true;
      }
      return component.pendingChangesDialog();
    } else {
      return true;
    }
  }
}

export interface WorkOrderFormUnsavedChangesInterface {
  getWorkOrderDetailsComponent: () => WorkOrderUnsavedChangesComponent;
}

export interface WorkOrderUnsavedChangesComponentInterface {
  canDeactivate(): boolean;
  pendingChangesDialog(): boolean | Observable<boolean>;
}

@Component({ template: '' })
export abstract class WorkOrderUnsavedChangesComponent implements WorkOrderUnsavedChangesComponentInterface {
  abstract canDeactivate(): boolean;
  abstract pendingChangesDialog(): boolean | Observable<boolean>;

  @HostListener('window:beforeunload', ['$event'])
  protected beforeUnloadEvent($event: BeforeUnloadEvent): void {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
